import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation('home');

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/4e922beecd6e1721d34bdd7a37c48757.jpg)'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/75 via-slate-900/70 to-slate-900/75"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-6 sm:mb-8 leading-tight px-2">
          {t('hero.title')}<br />{t('hero.subtitle')}
        </h1>
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-slate-200 leading-relaxed max-w-3xl mx-auto mb-8 sm:mb-12 px-4">
          {t('hero.description')}
        </p>
        <div className="bg-teal-600 text-white px-4 sm:px-6 md:px-8 py-3 sm:py-4 rounded-lg inline-block mb-8 sm:mb-10 text-lg sm:text-xl md:text-2xl font-bold mx-4">
          {t('hero.freeOffer')}
        </div>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4">
          <button
            onClick={scrollToContact}
            className="w-full sm:w-auto bg-teal-600 text-white px-8 sm:px-12 py-4 sm:py-5 rounded-lg font-bold text-base sm:text-lg hover:bg-teal-700 transition-all hover:-translate-y-1 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            {t('hero.contactButton')}
          </button>
          <button
            onClick={scrollToContact}
            className="w-full sm:w-auto bg-white/10 backdrop-blur-sm text-white px-8 sm:px-12 py-4 sm:py-5 rounded-lg font-semibold text-base sm:text-lg hover:bg-white/20 transition-all hover:-translate-y-1 border border-white/30 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-phone-line"></i>
            {t('hero.callButton')}
          </button>
        </div>
        <p className="text-slate-300 mt-6 text-sm sm:text-base px-4">
          {t('hero.pricing')}
        </p>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl opacity-60"></i>
      </div>
    </section>
  );
}
